import { IGetQuery } from 'ets-fe-ng-sdk';

export interface ISaveDocumentMetadata {
  companyCode?: string;
  docKey?: string;
  refCat?: ERefCat;
  refNo?: string;
  category?: string;
  docSensitivity?: string;
  fileName?: string;
}

export interface IDocumentMetadata extends ISaveDocumentMetadata {
  docKey: string;
  docCode: string;
  category: string;
  fileName: string;
  createdOn: string;
  id: number;
}

export type IDocumentMetadataSQ = IGetQuery<{
  docKey: string;
  company: string;
  fileName: string;
  refCat: ERefCat;
  refNo: string;
  ria: string;

  category: string;
  docCode: string;
}>;

export enum ERefCat {
  candidate = 'CD',
  company = 'COM',
  exam = 'EX',
  agent = 'AGT',
  user = 'USR',
  course = 'COU',
  help = 'HLP',
  adminHelp = 'ADMIN_HLP',
  lap = 'LAP',
  productLicense = 'PLI',
  valuation = 'AVC',
  regulation = 'REG',
  infraction = 'RIF',
  application = 'APN',
  claimThirdParty = 'TPC',
  claim = 'CLA',
}
